import { render } from "./midTitleBlock.vue?vue&type=template&id=405a1106&ts=true"
import script from "./midTitleBlock.vue?vue&type=script&lang=ts"
export * from "./midTitleBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__